import { render, staticRenderFns } from "./PotentialCustomers.vue?vue&type=template&id=cb85aa90&scoped=true"
import script from "./PotentialCustomers.vue?vue&type=script&lang=js"
export * from "./PotentialCustomers.vue?vue&type=script&lang=js"
import style0 from "./PotentialCustomers.vue?vue&type=style&index=0&id=cb85aa90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb85aa90",
  null
  
)

export default component.exports